import { useCallback, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import CheckSession from "@lib/utilities/CheckSession";
import { handleInvalidTokenCase } from "@lib/utilities/AuthHelper";
import { useAppDispatch, useAppSelector } from "@lib";
import { messages } from "../../../src/resources/strings";
import {
  resetPolicyDetail,
  setError,
  setLoading,
} from "@lib";
import { introspectionAPI } from "@lib";

import { PolicyType } from "@lib";
import { useNavigation } from "@react-navigation/native";
import { usePolicies } from "@lib";
import { updatePolicyDetails } from "@lib";

export const usePolicyDetails = (policies: PolicyType[]) => {
  const { logout } = useAuth0();
  const dispatch = useAppDispatch();
  const navigation = useNavigation();
  const { getPolicyDetail } = usePolicies();
  const isConnected = useAppSelector((state) => state.userReducer.isConnected);
  const { policyNumber } = useAppSelector((state) => state.policyReducer);

  //   Unautorised user handler
  const handleInvalidToken = () =>
    handleInvalidTokenCase(isConnected ?? false, navigation, logout, () => {});

  // network check
  const checkNetworkAndProceed = async (callback: () => Promise<void>) => {
    if (isConnected) {
      dispatch(setLoading(true));
      await callback();
    } else {
      await showInternetalert();
    }
  };
  const showInternetalert = async () => {
    dispatch(setError(messages.error.noError));
    setTimeout(() => {
      dispatch(setError(messages.error.youAreOffline));
    }, 10);
  };

  //   Policy Detail Api handler
  const callPolicyDetailData = async () => {
    try {
      if (policies != null && policyNumber != null) {
        dispatch(resetPolicyDetail());
        dispatch(setLoading(true));
        const res = await getPolicyDetail(policyNumber);
        if (res && res?.response) {
          dispatch(updatePolicyDetails(res?.response));
        } else {
          dispatch(setError(res?.errorCode));
        }
      }
      dispatch(setLoading(false));
    } catch (error: any) {
      console.log("error", error);
      dispatch(setLoading(false));
    }
  };

  const callIntrospectionAndDetailApi = () => {
    checkNetworkAndProceed(async () => {
      const introspectionResponse = await introspectionAPI();

      if (introspectionResponse.response) {
        callPolicyDetailData();
      } else {
        dispatch(setLoading(false));
        dispatch(setError(messages.error.resetPasswordLogout));
      }
    }).finally(() => {
      setTimeout(() => {
        dispatch(setLoading(false));
      }, 1000);
    });
  };
  const checkSession = useCallback(async () => {
    dispatch(setLoading(true));
    const session = await CheckSession();
    if (session) {
      dispatch(setError(""));
      callIntrospectionAndDetailApi();
    } else handleInvalidToken();
  }, []);

  return {
    fetchPolicyDetails: callPolicyDetailData,
  };
};
